<template>
    <div>
        <div class="newOne">
            <div class="content">
                <h2>纸搬客——互联网+时代的智能废纸回收先行者</h2>
                <p class="p-1"><img src="../../assets/img/newOne/4.png" class="img-1"><span class="span-1">大众新闻</span>2020年3月9号</p>
                <div class="details">
                    <p class="p-2">一次偶然的机会，在北京南华里小区初识纸搬客。出于好奇，我们与纸搬客创始人李嘉轩先生取得了联系，李总也将纸搬客这个广受北京市民喜爱的新型废纸回收项目进行了深入浅出的讲解。这才意识到，看似简单的一个废纸回收机，或将悄然掀起垃圾分类与智能回收的风潮，让废纸变得更有价值。</p>
                    <h3 class="h3-1">理想主义 环保初心</h3>
                    <h3 class="h3-1 h3-spe">垃圾分类背景下的纸类回收新模式</h3>
                    <p class="p-2">纸搬客诞生于2018年，时值国家重拳出击整治环保、垃圾分类政策相继出台的风口浪尖。据李总介绍，纸搬客的创始初衷其实很简单，就是便于日常生活中产生的大量废旧纸类垃圾进行精准分类和回收再利用，通过纸搬客建构的智能回收链，挖掘废纸的潜在价值，在保护环境的同时给用户带来一定的收益回馈。</p>
                    <img src="../../assets/img/newOne/1.png" alt="" class="img-2">
                    <p class="p-2">相关数据显示，我国每年人均耗纸量达33公斤，每制造50本书就需要砍伐1棵树；每年生产纸张1.07亿吨，而回收量仅为4832万吨，45%的资源因没有得到有效回收而被浪费。纸搬客希望可以将这些潜在的纸类资源加以有效回收再利用，这不仅会改变人们日常生活中纸类垃圾的处理方式，还将成为垃圾分类与环境保护的有益助力。</p>
                    <h3 class="h3-1">稳扎稳打 渐进布局</h3>
                    <h3 class="h3-1 h3-spe">由北京辐射全国的城市合伙人新理念</h3>
                    <p class="p-2 p-spe">纸搬客智能废纸回收机器一般安置在社区内，这样小区居民就可以在废纸垃圾产生的第一时间通过纸搬客进行回收，操作起来也非常便捷，用户只需手机下载纸搬客APP、扫描二维码然后进行投递即可，完成后会给予用户一定的积分奖励，用于在电子商城上进行商品兑换。</p>
                    <p class="p-2">据李总介绍，截至目前纸搬客用户量已接近一万户，商品兑换次数超过一万人次，深受广大用户的喜爱。正如笔者在南华里小区见到的李大妈所说，“自从有了纸搬客，家里的废纸垃圾都变成了米面油盐……”</p>
                    <img src="../../assets/img/newOne/2.png" alt="" class="img-2">
                    <p class="p-2 p-spe">目前纸搬客在北京丰台南华里、通州龙旺庄、密云长安等几个小区进行了布局，现在每台机器日均可回收废纸达60-100公斤。如果纸搬客模式在全国可以开展起来，这将是一个巨大的回收体量，对废纸资源的循环再利用和环境保护都将起到积极的促进作用。</p>
                    <img src="../../assets/img/newOne/3.png" alt="" class="img-2">
                    <p class="p-2">关于纸搬客如何在全国进行布局，李总是这样描述的：中国是一个巨大的市场，而纸搬客所做的又是和日常生活息息相关的事情，有了北京多个小区的成功经验，相信纸搬客接下去在全国的推广也一定会受到广大社区居民的喜欢。纸搬客将通过城市合伙人的模式，吸纳有环保情怀和创业意向的城市合伙人共同开发这个巨大的市场，为环保事业真正贡献一份力量。</p>
                    <h3 class="h3-1 h3-spe">结语：</h3>
                    <p class="p-2 p-spe">随着“未来经济”、“绿色经济”、“共享经济”等新业态新模式蓬勃发展，科技智能、绿色环保、便利高效成为了新时代的发展目标。纸搬客通过整合资源进行产业升级、以环保为核心打造产品、精准针对痛点需求搭建服务体系的模式，为方便社区百姓日常生活、提升全民环保意识提供了一个创新型的服务平台。最后，我们祝福纸搬客有一个美好的未来，让我们一起为纸搬客加油！</p>
                    <p class="p-2 p-spe">原标题：纸搬客——互联网+时代的智能废纸回收先行者</p>
                    <p class="p-1">责任编辑： 付晓萌_NB7161</p>
                </div>
            </div>
            <!-- footer -->
            <footer_s></footer_s>
        </div>
    </div>
</template>
<script>
    import footer_s from '../common/footer'
    export default {
        components: {
            footer_s
        },
    }
</script>
<style scoped>
    .newOne {
        width: 100%;
        height: 10rem;
        position: absolute;
        background-color: #fff;
        top: 0rem;
        left: 0;
        z-index: 100;
    }
    .content{
        width: 60%;
        height: 10rem;
        /* background-color:aquamarine; */
        margin: 0 auto;
        padding: 0 5%;
    }
    .content h2 {
        font-size: 0.13rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(14, 14, 14, 1);
        line-height: 0.2rem;
        margin-top: 0.1rem;
    }
    .img-1{
        width: 0.15rem;
        height: 0.15rem;
        border-radius: 50%;
        vertical-align: middle;
        margin: 0.03rem;
        margin-top: 0;
    }
    .span-1{
        font-size: 0.06rem;
        margin-right: 0.03rem;
    }
    .p-1 {
        font-size: 0.05rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(128, 128, 128, 1);
        line-height: 0.15rem;
        margin-top: 0.03rem;
    }
    .details{
        width: 100%;
    }
    .p-2{
        font-size:0.05rem;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(49,49,49,1);
        line-height:0.1rem;
        margin-bottom: 0.05rem;
    }
    .p-spe{
        margin-bottom: 0.08rem;
    }
    .h3-1{
        font-size: 0.1rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgb(71, 60, 60);
        line-height: 0.15rem;
    }
    .h3-spe{
        margin-bottom: 0.05rem;
    }
    .img-2{
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/views/newChild/newOne.vue